import Selected from "assets/img/sss.png";
import Image from "next/image";
type Options = {
  label: string;
  value: string | number | boolean;
};
type PropsType = {
  label?: string;
  name?: string;
  register?: any;
  required?: boolean;
  watch?: any;
  errors?: any;
  options: Options[] | string[];
  dir?: string;
  labelClassName?: string;
  optionContainerClassName?: string;
  parentClassName?: string;
  gap?: string;
  onChange?: any;
  pattern?: any;
  withoutLabel?: boolean;
  disabled?: boolean;
  boolean?: boolean;
};
const Checkbox: React.FC<PropsType> = ({
  name,
  register,
  required = false,
  watch,
  options,
  label,
  dir = "row",
  errors,
  labelClassName = "",
  optionContainerClassName = "",
  parentClassName = "",
  gap = "",
  onChange,
  pattern,
  withoutLabel = false,
  disabled = false,
  boolean = false,
}) => {
  const responsiveDirection = (): string => {
    if (dir === "row") {
      return `flex-row ${gap ? gap : `gap-4`}`;
    } else {
      return `flex-col  ${gap ? gap : `gap-2`}`;
    }
  };
  const validationStyle = () => {
    if (errors[name]) {
      return "border-red-600 border-2";
    } else {
      return "";
    }
  };

  const CheckInputsValue = (item) => {
    return (
      (watch(name) && typeof watch(name) == "boolean") ||
      (watch(name) && watch(name).includes(item.value))
    );
  };

  return (
    <div className={`py-3 ${parentClassName}`}>
      {!withoutLabel && (
        <p className={` capitalize font-semibold ${labelClassName}`}>
          {label ? label : name}:
        </p>
      )}

      <div className={`flex my-1 ${responsiveDirection()} flex-wrap`}>
        {boolean
          ? ["true", "false"].map((item, i) => (
              <div
                key={Math.random() + i + 2}
                className={`flex items-center gap-2 ${optionContainerClassName} ${
                  watch(name) == "true" && i === 0 ? " hidden" : ""
                } ${watch(name) == "false" && i === 1 ? " hidden" : ""}`}
              >
                <div
                  className={`w-5 h-5 rounded-full ${
                    disabled ? "cursor-not-allowed" : "cursor-pointer"
                  }  relative    ${validationStyle()}`}
                >
                  {watch(name) === "true" ? (
                    <div className="bg-[#F7F7F7] flex items-center justify-center w-[21.96px] h-[21.96px] rounded-md">
                      <Image src={Selected} alt="img" />
                    </div>
                  ) : (
                    <div className="bg-[#F7F7F7] flex items-center justify-center w-[21.96px] h-[21.96px] rounded-md"></div>
                  )}
                  <input
                    aria-label={label}
                    label={label ? label : name}
                    type="radio"
                    name={item}
                    value={item}
                    disabled={disabled}
                    defaultValue={item}
                    checked={CheckInputsValue(item)}
                    className={`absolute top-0 bottom-0 left-0 right-0 w-full h-full opacity-0 ${
                      disabled ? "cursor-not-allowed " : "cursor-pointer"
                    }`}
                    {...register(name, { onChange, required })}
                  />
                </div>
                <label
                  htmlFor={name}
                  className={` text-[#9D9D9D] w-max-content`}
                >
                  {label ? label : name}
                </label>
              </div>
            ))
          : options?.map?.((item, index: number) => (
              <div
                className={`flex items-center gap-2 ${optionContainerClassName} `}
                key={index + Math.random()}
              >
                <div
                  /*  role="checkbox" */
                  className={`w-5 h-5 rounded-full cursor-pointer relative   `}
                >
                  {CheckInputsValue(item) ? (
                    <div
                      className={`bg-[#F7F7F7] flex items-center justify-center w-[21.96px] h-[21.96px] rounded-md ${validationStyle()}`}
                    >
                      <Image src={Selected} alt="img" />
                    </div>
                  ) : (
                    <div
                      className={`bg-[#F7F7F7] flex items-center justify-center w-[21.96px] h-[21.96px] rounded-md ${validationStyle()}`}
                    ></div>
                  )}
                  <input
                    aria-label={label}
                    label={label ? label : name}
                    type="checkbox"
                    disabled={disabled}
                    require={required}
                    name={name}
                    value={item.value ? item.value : item}
                    /*  checked={CheckInputsValue(item)} */
                    className={`absolute top-0 bottom-0 left-0 right-0 w-full h-full opacity-0  ${
                      disabled ? "cursor-not-allowed " : "cursor-pointer"
                    }`}
                    {...register(name, { required, onChange })}
                  />
                </div>
                <label htmlFor={name} className="capitalize text-old-silver ">
                  {item.label}
                </label>
              </div>
            ))}
      </div>
    </div>
  );
};
export default Checkbox;
